







































































































































































import {Component, Mixins} from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import XForm from "@/components/SimpleForm.vue";
import ButtonWithMessage from "./ButtonWithMessage.vue";
import { signUpForm } from "@/assets/scripts/form-fields/main";
import AppApiMixin from "../mixins/AppApi.vue";
import VueRecaptcha from 'vue-recaptcha';
import {
  agreementAcceptedExtensionsArr,
  agreementAcceptedExtensions,
  agreementAcceptedFileSize,
  agreementAcceptedExtensionsHint,
  checkFiles,
} from "@/assets/scripts/file-inputs";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import DocGetterCard
  from "@/components/for-turnovers-and-reports-view/DocGetterCard.vue";
import DocGetterDialog
  from "@/components/for-turnovers-and-reports-view/DocGetterDialog.vue";
import {AxiosResponse} from "axios";
import DocGetterMixin from "@/components/mixins/DocGetter.vue";
import {mapGetters} from "vuex";

const { values, attrs, validations, errors } = signUpForm;

@Component({
  components: {
    DocGetterDialog, DocGetterCard, XNotice,
    XForm,
    ButtonWithMessage,
    VueRecaptcha
  },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapGetters({
      branchesList: "branches/branchesList",
      branchesListFormatted: "branches/branchesListFormatted",
    }),
    showAgreementCalc() {
      return this.branchID == 'SCS';
    },
  },
  validations,
})
class SignUpForm extends Mixins(AppApiMixin, XForm, DocGetterMixin) {
  [x: string]: any;
  values = values;

  allFieldAttrs = attrs;

  useSubmitButtonLoading = false;
  submitError = "";
  submitSuccess = "";

  downloadButtonLoading = false; // флаг состояния кнопки скачивания шаблона на регистрацию
  downloadButtonAgreementLoading = false; // флаг состояния кнопки скачивания согласия о расчетах

  siteKey = "";
  recaptchaEnabled = false;

  errorPatternFile: Array<String> | [] = [];
  errorAgreementCalcFile: Array<String> | [] = [];

  get branchID() {
    return this.branchesList.filter(_ => _.full_name == this.values['branch']).map(_ => _.name)[0] || "";
  }

  get noFile() {
    return (this.values['uploadPattern']?.length || 0) <= 0 || (this.showAgreementCalc && (this.values['uploadAgreementCalc']?.length || 0) <= 0);
  }

  changePatternFile(files: Array<File>) {
    this.errorPatternFile = checkFiles(files, agreementAcceptedExtensionsArr(), agreementAcceptedFileSize());
  }

  changeAgreementCalcFile(files: Array<File>) {
    this.errorAgreementCalcFile = checkFiles(files, agreementAcceptedExtensionsArr(), agreementAcceptedFileSize());
  }

  mounted() {
    this.siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY || "";
    this.recaptchaEnabled = (process.env.VUE_APP_RECAPTCHA_ENABLED || '') === "true";

    // список филиалов
    this.getBranches();
    if (this.branchesList.length <= 1) {
      this.values['branch'] = this.branchesListFormatted[0] != undefined ? (this.branchesListFormatted[0] || "") : "";
    }
    // конфиг
    this.getConfig();
  }

  getAgreementAcceptedExtensions() { return agreementAcceptedExtensions() }
  getAgreementAcceptedExtensionsHint() { return agreementAcceptedExtensionsHint() }

  public onCaptchaExpired() {
    //@ts-ignore
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.reset()
    }
  }

  public validate() {
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.execute()
    } else {
      this.submitForm('')
    }
  }

  submitForm(recaptchaToken: string) {
    this.submitError = "";
    this.submitSuccess = "";
    this.useSubmitButtonLoading = true;

    const formData = new FormData;
    for (let key in this.values) {
      if (key == 'uploadPattern' || key == 'uploadAgreementCalc') {
        if (this.values[key] && this.values[key][0]) {
          formData.append(key, this.values[key][0]);
        }
      } else if (key == 'branch') {
        formData.append(key, this.branchID);
      } else {
        formData.append(key, this.values[key]);
      }
    }
    formData.append('recaptchaToken', recaptchaToken);

    this.signUp(formData)
      .then((_) => {
        this.submitSuccess = "Заявка успешно отправлена";
      })
      .catch((e) => {
        this.submitError = e;
      })
      .finally(() => {
        this.useSubmitButtonLoading = false;
      });
  }

  public downloadFile(): void {
    const { downloadPatternRegistrationDocument, downloadDocument } = this;

    this.downloadButtonLoading = true;

    downloadPatternRegistrationDocument()
      .then((response: AxiosResponse) => {
        downloadDocument(response);
      })
      .catch((err: any) => console.log(err))
      .finally(() => {
        this.downloadButtonLoading = false;
      });
  }

  public downloadFileAgreementCalc():void {
    const { downloadAgreementCalcDocument, downloadDocument } = this;

    this.downloadButtonAgreementLoading = true;

    downloadAgreementCalcDocument()
      .then((response: AxiosResponse) => {
        downloadDocument(response);
      })
      .catch((err: any) => console.log(err))
      .finally(() => {
        this.downloadButtonAgreementLoading = false;
      });
  }

  /**
   * Скачивание файла согласия на обработку персональных данных
   */
  public downloadPdFile(): void {
    const { downloadPdDocument, downloadDocument } = this;

    this.downloadButtonLoading = true;

    downloadPdDocument(this.branchID || "")
      .then((response: AxiosResponse) => {
        downloadDocument(response);
      })
      .catch((err: any) => console.log(err))
      .finally(() => {
        this.downloadButtonLoading = false;
      });
  }
}

export default SignUpForm;
